import { useCallback, useState } from "react";
import clsx from "clsx";
import useClickAway from "@/core/helpers/useClickAway";
import { TriangleArrowUpIcon } from "@/shared/icons";
import { Checkbox } from "@/shared/ui";
import { ItemCategory } from "@/domains/inventory/constants/itemCategory";
import { itemCategoryTranslations } from "@/domains/inventory/helpers/itemCategoryTranslation";

type Props = {
  groups: ItemCategory[];
  selectedGroups: ItemCategory[];
  onSelect: (value: ItemCategory) => void;
};

export default function InventoryFilter({ groups, selectedGroups, onSelect }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const ref = useClickAway(() => {
    setIsOpen(false);
  });

  const onClickHandler = useCallback((e) => {
    e.stopPropagation();
    setIsOpen((state) => !state);
  }, []);

  const value = (
    <div className={clsx("shrink-0", selectedGroups.length ? "text-white" : "text-white/50")}>
      Фильтр {selectedGroups.length > 0 && `(${selectedGroups.length})`}
    </div>
  );

  return (
    <div ref={ref} className="relative flex items-center gap-2.5 group shrink-0 w-[6rem]">
      <button
        type="button"
        className="flex items-center justify-between gap-2 text-15 font-medium w-full"
        onClick={onClickHandler}
      >
        {value}
        <TriangleArrowUpIcon
          size={10}
          className={clsx(
            "transition-all shrink-0",
            selectedGroups.length ? "text-accent-solid" : "group-hover:text-white text-white/50",
            { "rotate-180": isOpen },
          )}
        />
      </button>
      <div className={clsx("absolute top-full right-0", isOpen ? "flex" : "hidden")}>
        <div
          className={clsx("w-fit flex-col py-2 flex z-10 bg-dark-800 rounded-[0.75rem] mt-4")}
          style={{
            boxShadow: "0px 10px 15px 0px #121212",
          }}
        >
          {groups.map((item, index) => {
            const checked = selectedGroups.includes(item);
            return (
              <button
                type="button"
                key={item}
                className="px-3.5 group"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onSelect(item);
                }}
              >
                <div
                  className={clsx("flex items-center gap-2.5 py-2.5 group", {
                    "border-b border-white/10": index !== groups.length - 1,
                  })}
                >
                  <Checkbox checked={checked} onChange={() => {}} variant="variant-2" />
                  <div
                    className={clsx(
                      "text-14 font-medium hover:text-accent-solid whitespace-nowrap transition-all",
                      { "text-accent-solid": checked },
                    )}
                  >
                    {itemCategoryTranslations[item]}
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
